import { useFlags } from '@atlaskit/flag';
import { AddLocationFormFields } from 'core/config/form-fields';
import { useDialog } from 'core/providers/DialogProvider';
import { showErrorFlag, showSuccessFlag } from 'core/utilities/flags-helper';
import { useState } from 'react';
import { IButton } from 'shared/components/buttons/button-interface';
import SharedDialogBase from 'shared/components/dialog-base/dialog-base';
import SharedForm from 'shared/components/form/form';
import { LocationsApiService } from 'core/api';
import { useAuthState } from 'core/providers/AuthProvider';
import { ILocationDao } from 'core/api/types';

const AddLocationDialog = () => {
  const { userData } = useAuthState();
  const flags = useFlags();
  const dialog = useDialog();

  const [formSubmitting, setFormSubmitting] = useState(false);

  const addLocation = async (data: ILocationDao) => {
    setFormSubmitting(true);
    try {
      await LocationsApiService.set(
        {
          active: data.active,
          name: data.name,
          address: data.address,
          phoneNumber: data.phoneNumber,
          emailAddress: data.emailAddress,
        },
        {
          fullName: userData?.fullName ?? '',
          uid: userData?.uid ?? '',
        }
      );
      showSuccessFlag('Location created', 'The location has been created successfully', flags);
      dialog?.closeDialog();
    } catch (error) {
      showErrorFlag('Location creation failed', `Unable to create a location, please try again.`, flags);
      setFormSubmitting(false);
    }
  };

  const cancelButton: IButton = {
    onClick: () => dialog?.closeDialog(),
    label: 'Cancel',
    appearance: 'subtle',
    type: 'button',
  };

  const customContent = () => {
    return (
      <SharedForm
        className='p-4 overflow-y-auto'
        onSubmit={addLocation}
        fields={AddLocationFormFields}
        buttonLabel='Submit'
        loading={formSubmitting}
        cancelButton={cancelButton}
      />
    );
  };

  return <SharedDialogBase title='Add location' customContentTemplate={customContent()} showButtons={false} />;
};

export default AddLocationDialog;
